// src/data/filterOptions.js

export const supplementForms = [
    'Capsule',
    'Chew',
    'Tablet',
    'Gummy',
    'Powder',
    'Liquid',
    'Softgel'
  ];

export const dietaryRestrictionsList = [
    { key: 'vegan', label: 'Vegan' },
    { key: 'vegetarian', label: 'Vegetarian' },
    { key: 'wheatFree', label: 'Wheat Free' },
    { key: 'glutenFree', label: 'Gluten Free' },
    { key: 'gelatinFree', label: 'Gelatin Free' },
    { key: 'nonGMO', label: 'Non-GMO' },
    { key: 'soyFree', label: 'Soy Free' },
    { key: 'fishFree', label: 'Fish Free' },
    { key: 'shellfishFree', label: 'Shellfish Free' },
    { key: 'dairyFree', label: 'Dairy Free' },
    { key: 'lactoseFree', label: 'Lactose Free' },
    { key: 'sesameFree', label: 'Sesame Free' },
    { key: 'treeNutFree', label: 'Tree Nut Free' },
    { key: 'peanutFree', label: 'Peanut Free' },
    { key: 'sugarFree', label: 'Sugar Free' },
    { key: 'sodiumFree', label: 'Sodium Free' },
    { key: 'cornFree', label: 'Corn Free' },
    { key: 'yeastFree', label: 'Yeast Free' },
    { key: 'eggFree', label: 'Egg Free' },
    { key: 'kosher', label: 'Kosher' },
    { key: 'milkFree', label: 'Milk Free' },
    { key: 'halal', label: 'Halal' },
    { key: 'noArtificialSweeteners', label: 'No Artificial Sweeteners' },
    { key: 'noArtificialFlavors', label: 'No Artificial Flavors' },
    { key: 'noArtificialColors', label: 'No Artificial Colors' },
    { key: 'noArtificialPreservatives', label: 'No Artificial Preservatives' }
  ];

export const healthGoalsList = [
    'General Wellness',
    'Energy & Performance',
    'Athletic Recovery',
    'Muscle Function & Strength',
    'Cognitive Function',
    'Sleep, Relaxation, & Mental Wellbeing',
    'Digestive Health',
    'Heart & Circulatory Health',
    'Bone, Joints & Inflammation Support',
    'Kidney Health',
    'Weight Management & Appetite',
    'Men\'s Health',
    'Women\'s Health',
    'Kids & Teens',
    'Hair, Skin & Nails',
    'Immune Support',
    'Antioxidant & Cellular Protection',
    'Longevity/Anti-aging',
    'Eye Health',
    'Allergy Support',
    'Liver Support & Detoxification',
    'Blood Sugar Management/Metabolic Health',
    'Thyroid Health',
    'Prenatal/Postnatal Support',
    'Urinary Tract Health',
    'Respiratory Health'
];

 export const ingredientCategories = [
    {
      category: 'Vitamin A group',
      ingredients: [
        'Vitamin A',
        'Beta-Carotene (Vit A)',
        'Retinyl Acetate (Vit A)',
        'Retinyl Palmitate (Vit A)'
      ]
    },
    {
      category: 'B Vitamins group',
      ingredients: [
        'Thiamine (B1)',
        'Riboflavin (B2)',
        'Riboflavin-5\'-Phosphate (B2)',
        'Niacin (B3)',
        'Niacinamide (Nicotinamide) (B3)',
        'Nicotinic Acid (B3)',
        'Inositol Hexanicotinate (B3)',
        'Pantothenic Acid (B5)',
        'Pyridoxine (B6)',
        'Pyridoxal-5-Phosphate (P-5-P) (B6)',
        'Biotin (B7)',
        'Folic Acid / Folate (B9)',
        '5-Methyltetrahydrofolate (5-MTHF) (B9)',
        'Folinic Acid (B9)',
        'Vitamin B12',
        'Cyanocobalamin B12',
        'Methylcobalamin B12'
      ]
    },
    {
      category: 'Other B-vitamin related compounds',
      ingredients: [
        'Choline',
        'Inositol',
        'D-Chiro Inositol',
        'Myo-Inositol',
        'PABA (Para-Aminobenzoic Acid)'
      ]
    },
    {
      category: 'Remaining Vitamins',
      ingredients: [
        'Vitamin C',
        'Vitamin D (D2, D3)',
        'Vitamin E',
        'Vitamin K (K1, K2)',
        'Vitamin K1 (as Phylloquinone or Phytonadione)',
        'Vitamin K2 (as Menaquinone-4 / MK-4)',
        'Vitamin K2 (as Menaquinone-7 / MK-7)'
      ]
    },
    {
      category: 'Essential Minerals (RDA)',
      ingredients: [
        'Calcium',
        'Chloride',
        'Chromium',
        'Copper',
        'Iodine',
        'Potassium Iodide',
        'Iron',
        'Carbonyl Iron',
        'Ferrous Fumarate',
        'Ferrous Gluconate',
        'Ferrous Sulfate',
        'Iron Bisglycinate (or Iron Chelate)',
        'Polysaccharide-Iron Complex',
        'Magnesium',
        'Magnesium Bisglycinate',
        'Magnesium Carbonate',
        'Magnesium Chelate',
        'Magnesium Chloride',
        'Magnesium Citrate',
        'Magnesium Glycinate',
        'Magnesium Hydroxide',
        'Magnesium Lysinate Glycinate',
        'Magnesium Malate',
        'Magnesium Orotate',
        'Magnesium Oxide',
        'Magnesium Sulfate',
        'Magnesium Taurate',
        'Magnesium Threonate',
        'Manganese',
        'Molybdenum',
        'Phosphorus',
        'Potassium',
        'Selenium',
        'Sodium',
        'Zinc'
      ]
    },
    {
      category: 'Trace (Non-RDA)',
      ingredients: [
        'Boron',
        'Lithium',
        'Silica',
        'Vanadium'
      ]
    },
    {
      category: 'Amino Acids',
      ingredients: [
        'Alanine',
        'Arginine',
        'Aspartic Acid',
        'BCAA Blend',
        'Beta-Alanine',
        'Carnitine',
        'Citrulline',
        'Cystine',
        'D-Aspartic Acid',
        'EAA Blend',
        'Glutamic Acid',
        'Glutamine',
        'Glycine',
        'Histidine',
        'Hydroxylysine',
        'Hydroxyproline',
        'Isoleucine',
        'Leucine',
        'Lysine',
        'Methionine',
        'Ornithine',
        'Phenylalanine',
        'Proline',
        'Serine',
        'Taurine',
        'Theanine',
        'Threonine',
        'Tryptophan',
        'Tyrosine',
        'Valine'
      ]
    },
    {
      category: 'Oils & Fatty Acids',
      ingredients: [
        'ALA',
        'Algal Oil',
        'Argan Oil',
        'CLA (Conjugated Linoleic Acid)',
        'Coconut Oil',
        'Docosahexaenoic Acid (DHA)',
        'Eicosapentaenoic Acid (EPA)',
        'Evening Primrose Oil',
        'Fish Oil',
        'Flaxseed',
        'Krill Oil',
        'Lecithin',
        'MCT (Medium-chain Triglycerides)',
        'Olive Oil',
        'Omega-3',
        'Omega-6',
        'Omega-9',
        'Policosanol',
        'Pumpkin Seed Oil/Extract',
        'Specialized Pro-resolving Mediators (SPMs)',
        'Sunflower Oil'
      ]
    },
    {
      category: 'Botanical & Herbal Extracts',
      ingredients: [
        'Acai Berry',
        'Aloe Vera',
        'Annatto',
        'Artichoke Leaf (Extract)',
        'Bamboo Extract',
        'Beet Root',
        'Bilberry Extract',
        'Black Cumin (Seed)',
        'Black Currant',
        'Black Pepper Extract',
        'Black Seed Oil',
        'Blueberry',
        'Boswellia Serrata',
        'Burdock Root',
        'Cat\'s Claw',
        'Celery',
        'Ceylon Cinnamon',
        'Chamomile Extract',
        'Chanca Piedra',
        'Cinnamon',
        'Coffee',
        'Coffee Bean Extract',
        'Cranberry',
        'Dandelion',
        'Echinacea',
        'Elderberry',
        'Eleutherococcus senticosus (Siberian Ginseng)',
        'Fennel Seed',
        'Fenugreek Extract',
        'Forsythia suspensa',
        'Garlic Extract',
        'Ginger',
        'Grape Seed Extract',
        'Grapefruit Seed Extract',
        'Green Coffee Bean Extract',
        'Green Tea Extract',
        'Guava Extract',
        'Hawthorn',
        'Horny Goat Weed',
        'Hops',
        'Horsetail',
        'Isatis tinctoria',
        'Jabuticaba',
        'Japanese sophora (Sophora japonica)',
        "Jerusalem Artichoke",
        'Jujube Extract',
        'Lemon',
        'Lemon Balm Extract',
        'Leptospermum scoparium (Flower)',
        'Licorice Root',
        'Lonicera japonica',
        'Maqui',
        'Mangosteen',
        'Matcha',
        'Milk Thistle',
        'Oat (straw) Extract',
        'Oil of Oregano Extract',
        'Olive Leaf Extract',
        'Panax ginseng (Korean Ginseng)',
        'Panax quinquefolius (American Ginseng)',
        'Passionflower Extract',
        'Peppermint Leaf (Extract)',
        'Pomegranate Extract',
        'Pygeum Bark',
        'Raspberry Leaf',
        'Red Grape',
        'Rose Hips',
        'Rosemary',
        'Saffron',
        'Sage Extract',
        'Saw Palmetto',
        'Schizonepeta tenuifolia',
        'Sesbania Extract',
        'Slippery Elm',
        'St. John\'s Wort',
        'Stinging Nettle',
        'Thyme Extract',
        'Toothed Clubmoss',
        'Tribulus Terrestris',
        'Turmeric',
        'Valerian Root',
        'Vitex trifolia',
        'Yarrow',
        'Yellow Dock'
      ]
    },
    {
      category: 'Mushrooms',
      ingredients: [
        'Agaricus Bisporus',
        'Chaga',
        'Cordyceps',
        'King Trumpet',
        'Lion\'s Mane',
        'Maitake',
        'Reishi',
        'Shiitake',
        'Turkey Tail'
      ]
    },
    {
      category: 'Probiotics',
      ingredients: [
        'Bacillus clausii',
        'Bacillus coagulans',
        'Bacillus subtilis',
        'Bifidobacterium Species',
        'Lactobacillus Species',
        'Probiotic Blend',
        'Saccharomyces boulardii'
      ]
    },
    {
      category: 'Prebiotics & Fibers',
      ingredients: [
        'Acacia Fiber',
        'Beta-Glucan',
        'Blue Agave',
        'Chicory Root',
        'Corn Fiber',
        'D-Mannose',
        'Fiber',
        'FOS (Fructooligosaccharides)',
        'Glucomannan',
        'GOS (Galactooligosaccharides)',
        'Inulin',
        'Methylcellulose',
        'Oat Bran',
        'Pectin',
        'Potato (Resistant Starch)',
        'Prebiotic Blend',
        'Psyllium',
        'Rice Fiber',
        'Tapioca Fiber',
        'Wheat Dextrin',
        'XOS (Xylooligosaccharides)',
        'Xylitol'
      ]
    },
    {
      category: 'Digestive Enzymes',
      ingredients: [
        'Acid Protease',
        'Alpha-Galactosidase',
        'Amylase',
        'Beta-Glucanase',
        'Bromelain',
        'Cellulase',
        'Digestive Enzymes',
        'Glucoamylase',
        'Hemicellulase',
        'Invertase',
        'Lactase',
        'Lipase',
        'Maltase',
        'Ox Bile Extract/Powder',
        'Papain',
        'Pectinase',
        'Peptidase',
        'Phytase',
        'Protease',
        'Xylanase'
      ]
    },
    {
      category: 'Joint Support',
      ingredients: [
        'Chondroitin',
        'Collagen Peptides (Hydrolyzed Collagen)',
        'Bovine Collagen',
        'Chicken Collagen',
        'Eggshell Membrane Collagen',
        'Marine Collagen',
        'Glucosamine',
        'Hyaluronic Acid',
        'MSM (Methylsulfonylmethane)'
      ]
    },
    {
      category: 'Protein Sources',
      ingredients: [
        'Bone Broth',
        'Hydrolyzed Keratin',
        'Protein',
        'Brown rice protein',
        'Casein Protein',
        'Egg protein',
        'Hemp protein',
        'Pea protein',
        'Soy protein',
        'Whey protein'
      ]
    },
    {
      category: 'Performance & Energy',
      ingredients: [
        'Adenosine Triphosphate (ATP)',
        'Betaine',
        'Caffeine',
        'Citric Acid',
        'CoQ10 (Coenzyme Q10)',
        'Creatine Monohydrate',
        'D-Ribose',
        'HMB (Beta-Hydroxy Beta-Methylbutyrate)',
        'Malic Acid',
        'Maltodextrin'
      ]
    },
    {
      category: 'Cognitive & Nootropic Compounds',
      ingredients: [
        '5-HTP',
        'Alpha-GPC',
        'Bacopa monnieri',
        'GABA',
        'Ginkgo Biloba',
        'Gotu Kola',
        'Huperzine A',
        'Phosphatidylserine',
        'Uridine'
      ]
    },
    {
      category: 'Antioxidants & Protective Compounds',
      ingredients: [
        'Alpha Lipoic Acid',
        'Astaxanthin',
        'Berberine',
        'Carvacrol',
        'Chlorophyllin',
        'Citrus Bioflavonoids Extract',
        'Curcumin',
        'DIM (Diindolylmethane)',
        'Glutathione',
        'Hesperidin',
        'Lutein',
        'Lycopene',
        'Melatonin',
        'NAC (N-Acetyl Cysteine)',
        'Palmitoylethanolamide (PEA)',
        'Pterostilbene',
        'Quercetin',
        'Resveratrol',
        'Thymoquinone',
        'Zeaxanthin'
      ]
    },
    {
      category: 'Longevity & Cellular Health',
      ingredients: [
        '2\'-Deoxyadenosine',
        '2\'-Deoxycytidine',
        '2\'-Deoxyguanosine',
        'Adenine',
        'NAD+ (Nicotinamide Adenine Dinucleotide)',
        'NMN (Nicotinamide Mononucleotide)',
        'NR (Nicotinamide Riboside)',
        'PQQ (Pyrroloquinoline Quinone)',
        'SAMe',
        'Spermidine',
        'Thymidine',
        'Urolithin A'
      ]
    },
    {
      category: 'Adaptogens',
      ingredients: [
        'Ashwagandha',
        'Astragalus',
        'Holy Basil (Tulsi)',
        'Maca Root',
        'Rhodiola Rosea',
        'Schisandra',
        'Tongkat Ali'
      ]
    },
    {
      category: 'Greens & Superfoods',
      ingredients: [
        'Acerola',
        'Alfalfa',
        'Amla Fruit Extract',
        'Apple',
        'Asparagus',
        'Barley Grass',
        'Blackberry',
        'Bladderwrack Extract',
        'Broccoli Powder',
        'Brown Rice',
        'Brussels Sprout',
        'Cabbage Powder',
        'Camu Camu Powder',
        'Carrot Powder',
        'Cauliflower',
        'Cherry Fruit Powder/Extract',
        'Chlorella',
        'Cucumber',
        'Fulvic/Humic Acid',
        'Goji Berry Powder/Extract',
        'Green Bell Pepper',
        'Green Onion',
        'Kale Powder',
        'Kelp Powder/Extract',
        'Lucuma Powder',
        'Moringa (Horseradish Tree)',
        'Noni Fruit Powder',
        'Nori Extract',
        'Oat Grass',
        'Orange',
        'Papaya Fruit Powder',
        'Parsley',
        'Passionfruit',
        'Peach',
        'Pineapple Fruit Powder',
        'Raspberry',
        'Red Algae',
        'Red Cabbage',
        'Sea Moss',
        'Spinach Powder',
        'Spirulina',
        'Strawberry',
        'Tart Cherry',
        'Tomato',
        'Wakame Extract',
        'Wheatgrass'
      ]
    },
    {
      category: 'Trending Ingredients',
      ingredients: [
        'Apigenin',
        'Bee Propolis',
        'Beef Liver',
        'Cistanche',
        'Colostrum',
        'Royal Jelly',
        'Shilajit',
        'Sulforaphane'
      ]
    },
    {
      category: 'Food-Based Ingredients',
      ingredients: [
        'Apple Cider Vinegar',
        'Cane Sugar',
        'Cocoa Powder/Extract',
        'Coconut Milk',
        'Honey',
        'Manuka Honey (Powder)',
        'Monk Fruit Extract',
        'Stevia'
      ]
    }
  ];
